// Module
var code = `<branches-list detail-link="#!/admin/organization/holidays"></branches-list>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/holiday/holiday-branches.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;